<c-container class="mt-5">
  <h2>Signal R Connections</h2>
  <div><span class="bold-text">Total # of Active connections: {{ originalConnections.length }}</span></div>
  <div class="flex-row-wrap justify-space-between align-center margin-top-large">
    <mat-form-field class="flex-50" appearance="outline">
      <mat-label>Group / Game Id</mat-label>
      <input matInput placeholder="enter game id" [(ngModel)]="gameIdFilter" (ngModelChange)="filterOnGameType($event)"
             data-testid="signal-r-group-id">
      <button
        mat-icon-button
        matSuffix
        *ngIf="gameIdFilter"
        (click)="filterOnGameType('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field class="flex-50" appearance="outline">
      <mat-label>User Type</mat-label>
      <mat-select placeholder="enter user type" data-testid="user-type-select"
                  (selectionChange)="filterOnUserType($event)">
        <mat-option [value]="">---</mat-option>
        <mat-option [value]="'Player'">Player</mat-option>
        <mat-option [value]="'Admin'">Admin</mat-option>
        <mat-option [value]="'Unauthenticated User'">Unauthenticated User</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <mat-card class="margin-top-large">
    <mat-card-content>
      <table mat-table [dataSource]="dataSource" class="full-width-table">

        <!-- User Type Column -->
        <ng-container matColumnDef="userType">
          <th mat-header-cell *matHeaderCellDef> User Type </th>
          <td mat-cell *matCellDef="let connection"> {{ connection.UserType }} </td>
        </ng-container>

        <!-- User Id Column -->
        <ng-container matColumnDef="userId">
          <th mat-header-cell *matHeaderCellDef> User Id </th>
          <td mat-cell *matCellDef="let connection">
            <ng-container [ngSwitch]="connection.UserType">
            <span *ngSwitchCase="'Player'">
              <a [routerLink]="'/manage-player/' + connection.UserId">{{ connection.UserId }}</a>
            </span>
              <span *ngSwitchCase="'Admin'">
              <a [routerLink]="'/cross-game-user-details/' + connection.UserId">{{ connection.UserId }}</a>
            </span>
              <span *ngSwitchDefault>{{ connection.UserId }}</span>
            </ng-container>
          </td>
        </ng-container>

        <!-- Connection Id Column -->
        <ng-container matColumnDef="connectionId">
          <th mat-header-cell *matHeaderCellDef> Connection Id </th>
          <td mat-cell *matCellDef="let connection"> {{ connection.ConnectionId }} </td>
        </ng-container>

        <!-- Game Id Column -->
        <ng-container matColumnDef="gameId">
          <th mat-header-cell *matHeaderCellDef> Game Id </th>
          <td mat-cell *matCellDef="let connection"> {{ connection.GameId }} </td>
        </ng-container>

        <!-- Connected At Column -->
        <ng-container matColumnDef="connectedAt">
          <th mat-header-cell *matHeaderCellDef> Connected Since </th>
          <td mat-cell *matCellDef="let connection">
            {{ connection.ConnectedAt | date : 'yyyy-MM-dd HH:mm a' }}
          </td>
        </ng-container>
        <!-- Duration Column -->

        <ng-container matColumnDef="duration">
          <th mat-header-cell *matHeaderCellDef> Duration </th>
          <td mat-cell *matCellDef="let connection">
            {{ connection.ConnectedAt | connectionDuration: currentTime }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <!-- Paginator -->
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </mat-card-content>

  </mat-card>
</c-container>
